import * as numeral from 'numeral';
import * as React from 'react';

export type ExtractorType = (
  audio: HTMLAudioElement,
  providedDuration: number,
) => [value: number, refreshOnEvents: Array<keyof HTMLMediaElementEventMap>];

type Props = {
  audio: HTMLAudioElement;
  extractor: ExtractorType;
  providedDuration: number;
};

const TimeCode = ({audio, extractor, providedDuration}: Props) => {
  const [value, setValue] = React.useState(
    () => extractor(audio, providedDuration)[0],
  );

  React.useEffect(() => {
    const [newValue, events] = extractor(audio, providedDuration);
    setValue(newValue);
    const handler = () => {
      setValue(extractor(audio, providedDuration)[0]);
    };
    for (const event of events) {
      audio.addEventListener(event, handler);
    }
    return () => {
      for (const event of events) {
        audio.removeEventListener(event, handler);
      }
    };
  }, [audio, extractor]);

  return <span>{numeral(value).format('00:00:00')}</span>;
};

export default TimeCode;

export const extractCurrentPosition: ExtractorType = (
  audio: HTMLAudioElement,
  providedDuration: number,
) => [Math.floor(audio.currentTime), ['timeupdate']];

export const extractDuration: ExtractorType = (
  audio: HTMLAudioElement,
  providedDuration: number,
) => [audio.duration || providedDuration, ['durationchange']];

export const extractRemainingDuration: ExtractorType = (
  audio: HTMLAudioElement,
  providedDuration: number,
) => [
  Math.ceil((audio.duration || providedDuration) - audio.currentTime),
  ['durationchange', 'timeupdate'],
];
